export const SET_CASH_REGISTERS = 'SET_CASH_REGISTERS'      
export const ADD_CASH_REGISTER = 'ADD_CASH_REGISTER'      
export const UPDATE_CASH_REGISTER = 'UPDATE_CASH_REGISTER' 
export const DELETE_CASH_REGISTER = 'DELETE_CASH_REGISTER' 
export const SET_CURRENT_CASH_REGISTER = 'SET_CURRENT_CASH_REGISTER'